const inlineStyles = {

  modalBody: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '30px',
      color: 'white',
      width: '100%',
      maxWidth: '500px',
      marginLeft: 'auto',
      marginRight: 'auto'
  }

}

export default inlineStyles
